import { gql } from '@apollo/client';

export const AUDIT_BY_RECORD = gql`
  query AuditByRecord($table: String!, $pkValue: String!, $limit: Int, $offset: Int) {
    auditByRecord(table: $table, pkValue: $pkValue, limit: $limit, offset: $offset) {
      id
      occurredAt
      actorId
      actorName
      action
      tableName
      pkName
      pkValue
      changedCols
      before
      after
      requestId
    }
  }
`;
export const LOG_EXPORT_AUDIT_EVENT = gql`
  mutation LogExportAuditEvent($dashboard: String!, $monthYear: String!) {
    logExportAuditEvent(dashboard: $dashboard, monthYear: $monthYear)
  }
`;

export const AUDIT_ALL = gql`
  query AuditAll($startDate: String, $endDate: String, $limit: Int! = 20, $offset: Int! = 0) {
    auditAll(startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset) {
      id
      occurredAt
      actorId
      actorName
      action
      tableName
      pkName
      pkValue
      changedCols
      before
      after
      requestId
    }
  }
`;

export const AUDIT_OATT = gql`
  query AuditOatt($startDate: String, $endDate: String, $limit: Int, $offset: Int) {
    auditOatt(startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset) {
      id
      occurredAt
      actorId
      actorName
      action
      tableName
      pkName
      pkValue
      changedCols
      before
      after
      requestId
    }
  }
`;

export const AUDIT_OATT_COUNT = gql`
  query AuditOattCount($startDate: String, $endDate: String) {
    auditOattCount(startDate: $startDate, endDate: $endDate)
  }
`;

export const AUDIT_BY_OATT_CUSTOMER = gql`
  query AuditByOattCustomer($customerId: Int!, $startDate: String, $endDate: String, $limit: Int, $offset: Int) {
    auditByOattCustomer(customerId: $customerId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset) {
      id occurredAt actorId actorName action tableName pkName pkValue changedCols before after requestId
    }
  }
`;

export const AUDIT_SUMMARY = gql`
  query AuditSummary($startDate: String, $endDate: String) {
    auditSummary(startDate: $startDate, endDate: $endDate) {
      category
      occurrences
    }
  }
`;

export const AUDIT_BY_METER = gql`
  query AuditByMeter($meterId: Int!, $startDate: String, $endDate: String, $limit: Int, $offset: Int) {
    auditByMeter(meterId: $meterId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset) {
      id
      occurredAt
      actorId
      actorName
      action
      tableName
      pkName
      pkValue
      changedCols
      before
      after
      requestId
    }
  }
`;